export default __webpack_public_path__ + "static/char-13-93dfdd06ece0fed31ca4011a8c0e0dc8.gif";